import type { FC } from 'react';
import { Fragment } from 'react';
import classnames from 'classnames';

import OddValue from 'app/components/OddValue';
import warningIcon from 'app/icons/warning_empty.svg';
import Icon from 'app/components/Icon';
import type { FilteredOdds, MatchPreviewTeam } from 'app/components/MatchPreview/types';

import style from './style.scss';

interface Props {
  matchId: number;
  team: MatchPreviewTeam;
  className?: string;
  animationPosition: 'right' | 'left';
  filteredOdds: FilteredOdds;
}

const CompetitorsOddsValues: FC<Props> = ({
  matchId,
  team,
  animationPosition,
  className,
  filteredOdds
}) => {
  if (!filteredOdds.market) return null;

  const oddValue = filteredOdds.market.selections.reduce<number | null>((acc, selection) => {
    if (selection.participant_id === team.id) {
      return selection.probability_with_margin;
    }

    return acc;
  }, null);

  const increaseClassName =
    animationPosition === 'left' ? style.leftAnimationIncrease : style.rightAnimationIncrease;

  const decreaseClassName =
    animationPosition === 'left' ? style.leftAnimationDecrease : style.rightAnimationDecrease;

  const value = filteredOdds.market.status === 'gone' ? null : oddValue;

  return (
    <Fragment key={`${filteredOdds.market.market_id}-${filteredOdds.slug}`}>
      {filteredOdds.market.status === 'error' || filteredOdds.competitorStatus === 'down' ? (
        <Icon className={style.errorIcon} href={warningIcon} />
      ) : (
        <OddValue
          competitorValue
          key={matchId}
          value={value}
          className={classnames(
            style.competitorOddValue,
            {
              [style.suspended]: filteredOdds.market.status === 'suspended',
              [style.deactivated]: filteredOdds.market.status === 'deactivated'
            },
            className
          )}
          increaseClassName={increaseClassName}
          decreaseClassName={decreaseClassName}
        />
      )}
    </Fragment>
  );
};

CompetitorsOddsValues.displayName = 'CompetitorsOddsValues';

export default CompetitorsOddsValues;
